// Joins Danish names naturally: "A", "A og B", "A, B og C"
export function formatGusmesterNames(names: string[]): string {
  if (names.length === 0) return '';
  if (names.length === 1) return names[0];
  return `${names.slice(0, -1).join(', ')} og ${names[names.length - 1]}`;
}
